// extracted by mini-css-extract-plugin
export var container = "_uj-0";
export var table = "_uj-2";
export var tableWrapper = "_uj-1";